import Vue from 'vue'
import VueRouter from 'vue-router'
import VideoList from '../views/VideoList.vue'
import VideoDetail from '../views/VideoDetail.vue'
import VideoViews from '../views/VideoViews.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'VideoList',
    component: VideoList
  },
  {
    path: '/video/:id',
    name: 'VideoDetail',
    component: VideoDetail,
    props: true
  },
  {
    path: '/videoviews',
    name: 'VideoViews',
    component: VideoViews
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

